<template>
  <div class="comp-container">
    <div class="adjust-tips" v-if="showAdjustTips">
      <img
        src="@saas/pages/assets/images/video-play/tips.png"
        alt=""
      />视频文件已调整，请您仔细核对笔记
    </div>
    <div
      class="content-container"
      :class="{ 'content-container-show-adjust-tips': showAdjustTips }"
      v-if="!isLive"
    >
      <div class="header">
        <div class="lesson-name">
          {{ lessonInfo && lessonInfo.lesson_name }}
        </div>
        <div class="handle-tip">
          <div class="tips" v-if="isShowSuccess">
            <img
              src="@saas/pages/assets/images/course-card/success.png"
              alt=""
            />
            <p>保存成功</p>
          </div>
          <div class="tips" v-if="isShowFail">
            <img src="@saas/pages/assets/images/course-card/fail.png" alt="" />
            <p>保存失败</p>
          </div>
        </div>
      </div>
      <div
        class="main"
        :class="{
          'editor-container-disabled': editorReadOnly,
        }"
      >
        <!-- <ZxKatex :content="html"></ZxKatex> -->
        <wang-editor
          ref="editor"
          class="editor"
          :value="initNoteContent"
          placeholder="请填写您的笔记"
          :toolbarKeys="toolbarKeys"
          @created="onEditorCreated"
          @noticeInsertMarkBlock="noticeInsertMarkBlock"
          @noticeInsertVideoScreenShot="noticeInsertVideoScreenShot"
          @noticeJumpPlayTime="noticeJumpPlayTime"
          @keydown.native="onKeydown"
          @input="onInputEditor"
          :lessonInfo="handleLessonInfo"
          :readOnly="editorReadOnly"
        ></wang-editor>
        <div class="handle-box">
          <div
            class="export-btn btn"
            :class="{ disabled: isEmpty || editorReadOnly }"
            @click="onClickExport"
          >
            导出
          </div>
          <div
            class="save-btn btn"
            :class="{ disabled: isEmpty || editorReadOnly }"
            @click="onClickSave(true)"
          >
            保存
          </div>
        </div>
      </div>
    </div>
    <div class="live-box" v-else>
      <img src="@saas/pages/assets/images/course-card/empty.png" alt="" />
      <p>直播课时，无法记录笔记</p>
    </div>

    <leave-dialog
      :show.sync="leaveDialogVisible"
      :append-to-body="true"
      title=""
    >
      <div class="remove-conent">
        <p class="tips">您填写的笔记尚未保存</p>
        <div class="btn-box">
          <el-button type="default" size="small" @click="cancelSave">
            暂不保存
          </el-button>
          <el-button type="primary" size="small" @click="confirmLeave">
            立即保存
          </el-button>
        </div>
      </div>
    </leave-dialog>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions } from "vuex";
import { marked } from "marked";
import { EventBus } from "@saas/components/src/utils/event-bus";
import WangEditor from "@saas/components/src/components/wang-editor/Index.vue";
import { saveLessonNote } from "@saas/server-api/src/course";
import MgDialog from "@saas/components/src/components/mg-dialog/Index.vue";
import {
  extractTextFromHtml,
  getLessonIdFromReplayWinUrl,
} from "@saas/components/src";
// import ZxKatex from "@saas/components/src/components/zx-katex";
const test1 = `以下分别为随机生成的10个数学公式、10个物理公式和10个化学公式：\n\n### 数学公式\n1. $y = 3x + 5$\n2. $a^2 + b^2 = c^2$（勾股定理）\n3. $S = \\pi r^2$（圆的面积公式）\n4. $V = \\frac{4}{3}\\pi r^3$（球的体积公式）\n5. $y = \\sin(x)$\n6. $y = \\cos(x)$\n7. $y = e^x$\n8. $\\log_a b = \\frac{\\log_c b}{\\log_c a}$（换底公式）\n9. $C_n^k=\\frac{n!}{k!(n - k)!}$（组合数公式）\n10. $\\sum_{i = 1}^n i=\\frac{n(n + 1)}{2}$（自然数求和公式）\n\n### 物理公式\n1. $v = v_0 + at$（匀变速直线运动速度公式）\n2. $s = v_0t+\\frac{1}{2}at^2$（匀变速直线运动位移公式）\n3. $F = ma$（牛顿第二定律）\n4. $W = Fs$（功的计算公式）\n5. $P = \\frac{W}{t}$（功率定义式）\n6. $E_k=\\frac{1}{2}mv^2$（动能公式）\n7. $E_p = mgh$（重力势能公式）\n8. $F_{浮}=\\rho_{液}gV_{排}$（阿基米德原理）\n9. $I = \\frac{U}{R}$（欧姆定律）\n10. $Q = I^2Rt$（焦耳定律）\n\n### 化学公式\n1. $2H_2 + O_2 \\stackrel{点燃}{=\\!=\\!=} 2H_2O$（氢气燃烧）\n2. $C + O_2 \\stackrel{点燃}{=\\!=\\!=} CO_2$（碳完全燃烧）\n3. $2KMnO_4 \\stackrel{\\triangle}{=\\!=\\!=} K_2MnO_4 + MnO_2 + O_2↑$（高锰酸钾制氧气）\n4. $CaCO_3 + 2HCl =\\!=\\!= CaCl_2 + H_2O + CO_2↑$（实验室制二氧化碳）\n5. $Zn + H_2SO_4 =\\!=\\!= ZnSO_4 + H_2↑$（实验室制氢气）\n6. $H_2SO_4 + 2NaOH =\\!=\\!= Na_2SO_4 + 2H_2O$（硫酸与氢氧化钠中和反应）\n7. $Fe + CuSO_4 =\\!=\\!= FeSO_4 + Cu$（铁与硫酸铜反应）\n8. $2Mg + O_2 \\stackrel{点燃}{=\\!=\\!=} 2MgO$（镁燃烧）\n9. $CH_4 + 2O_2 \\stackrel{点燃}{=\\!=\\!=} CO_2 + 2H_2O$（甲烷燃烧）\n10. $2CO + O_2 \\stackrel{点燃}{=\\!=\\!=} 2CO_2$（一氧化碳燃烧）`;
// const test =("如果你身处密室逃脱的环境，可以按照以下步骤逃生：\n\n1. **观察环境**：首先，仔细观察密室内的物品，特别是耳鼻喉科诊室内的物品，如凸面镜、凹面镜、碘酒、镊子、空调、钟表、椅子、桌子等。\n\n2. **寻找线索**：注意木板下方是否有通道，以及窗户上的铁栅栏和阳光的射入情况。\n\n3. **应用物理知识**：\n   - **凹面镜聚光**：使用凹面镜将阳光汇聚到螺栓上，加热螺栓使其膨胀。\n   - **热胀冷缩**：利用空调的冷风使螺栓收缩，从而松动螺栓。\n   - **打开木板**：松动螺栓后，打开木板，找到逃生的通道。\n\n4. **确保安全**：在逃生过程中，确保每一步都安全进行，避免受伤。\n\n通过以上步骤，你可以成功从密室中逃生。");
const test2 = `1. 变力作用下的曲线运动**  质量为 \\( m \\) 的质点在力 \\[ \\vec{F} = -k(x^2 \\hat{i} + y^2 \\hat{j}) \\] 作用下运动，初始时刻质点位于原点，初速度为 \\[ \\vec{v}_0 = v_0 \\hat{i} \\]。  （1）证明质点的轨迹在 \\( x-y \\) 平面内；  （2）求质点运动到第一象限时速度的表达式。**2. 刚体复合运动**  半径为 \\( R \\) 的均质圆盘以角速度 \\( \\omega \\) 绕中心轴旋转，同时圆盘中心以速度 \\( v \\) 沿斜面向上纯滚动。  （1）推导圆盘边缘任意一点的加速度矢量；  （2）若斜面倾角为 \\( \theta \\)，求使圆盘不打滑的最小摩擦系数。**3. 非惯性系动力学**  光滑水平桌面上有一质量为 \\( m \\) 的小球，通过不可伸长的轻绳与质量为 \\( M \\) 的物块相连，物块从桌面边缘自由下落。当绳与竖直方向成 \\( 30^\\circ \\) 角时：  （1）求此时小球相对桌面的加速度；  （2）分析绳中张力的变化规律`;
export default {
  name: "Notes",
  components: {
    // ZxKatex,
    WangEditor,
    LeaveDialog: MgDialog,
  },
  inject: ["registerComponent", "unregisterComponent"],
  props: {
    lessonInfo: {
      type: Object,
      default: () => {},
    },
    componentId: {
      type: [String, Number],
      default: null,
    }, //组件标识
  },
  data() {
    return {
      // toolbarKeys: [
      //   "insertFormula",
      //   "bold",
      //   "italic",
      //   "underline",
      //   "|",
      //   "xhVideoScreenShotKey",
      //   "xhMarkBlockKey",
      // ],
      exportBtnDisabled: false,
      editor: null,
      editorText: "",
      isShowSuccess: false,
      isShowFail: false,
      leaveDialogVisible: false,
      leaveCallback: null,
      isEmpty: false,
      editorReadOnly: false,
    };
  },
  mounted() {
    this.offEvents();
    this.registerEvents();
    if (["video-play-note", "ai-mode-note"].includes(this.componentId)) {
      window.addEventListener("beforeunload", this.onBeforeunload);
      document.addEventListener(
        "visibilitychange",
        this.onDocumentVisibleChange
      );
      if (this.registerComponent) {
        this.registerComponent(this);
      }
    }
  },
  beforeDestroy() {
    this.offEvents();
    if (["video-play-note", "ai-mode-note"].includes(this.componentId)) {
      window.removeEventListener("beforeunload", this.onBeforeunload);
      // document.removeEventListener(
      //   "visibilitychange",
      //   this.onDocumentVisibleChange
      // );
      if (this.unregisterComponent) {
        this.unregisterComponent(this);
      }
      if (!this.leaveCallback) {
        this.onClickSave(false);
      }
    }
  },
  methods: {
    ...mapMutations("replay", ["setNoteContent", "setInitNoteContent"]),
    ...mapActions("replay", ["apiGetNoteInfo"]),
    // onDocumentVisibleChange() {
    //   if (document.visibilityState === "hidden") {
    //     // 当标签页隐藏（切离该页面）时执行的代码
    //     console.log("当前标签页被隐藏，即将切换到其他标签页");
    //     // 在这里可以添加你想要执行的拦截逻辑，例如阻止某些操作、保存当前状态等
    //   } else if (document.visibilityState === "visible") {
    //     // 当标签页显示（切换到该页面）时执行的代码
    //     console.log("当前标签页被显示，切换到了当前标签页");
    //   }
    // },
    onBeforeunload(event) {
      // 这是 Chrome、Firefox 等浏览器的写法
      if (window.isElectron) {
        if (
          this.noteContent !== this.initNoteContent &&
          !(this.noteContent === "<p><br></p>" && this.initNoteContent === "")
        ) {
          this.leaveDialogVisible = true;
          this.leaveCallback = () => {
            if (window.location.hash.startsWith("#/replay/")) {
              // 关闭窗口
              window.ReplyElectronApi.closeWin();
            } else {
              window.location.reload();
            }
          };
          event.preventDefault();
          return (event.returnValue = "你确定要离开此页面吗？");
        } else {
          console.log(333);
        }
      } else {
        event.preventDefault();
        return (event.returnValue = "你确定要离开此页面吗？");
      }
    },
    onInputEditor(val) {
      this.setNoteContent(val);
      this.isEmpty = this.editor.getHtml() === "<p><br></p>";
    },
    onKeydown(e) {
      e.stopPropagation();
    },
    offEvents() {
      EventBus.$off(`handle-insert-mark-block-${this.componentId}`);
      EventBus.$off(`handle-insert-video-screen-shot-${this.componentId}`);
      EventBus.$off(`handle-insert-qa-block-${this.componentId}`);
      EventBus.$off(`handle-insert-html-${this.componentId}`);
      EventBus.$off(`closeReplyWin`);
    },
    registerEvents() {
      EventBus.$on(
        `handle-insert-mark-block-${this.componentId}`,
        this.handleInsertMarkBlock
      );
      EventBus.$on(
        `handle-insert-video-screen-shot-${this.componentId}`,
        this.handleInsertImage
      );
      EventBus.$on(
        `handle-insert-qa-block-${this.componentId}`,
        this.handleInsertQABlock
      );
      EventBus.$on(
        `handle-insert-html-${this.componentId}`,
        this.handleInsertHtml
      );
      if (window.isElectron && window.location.hash.startsWith("#/replay/")) {
        EventBus.$on("closeReplyWinByToolBar", () => {
          if (
            this.noteContent !== this.initNoteContent &&
            !(this.noteContent === "<p><br></p>" && this.initNoteContent === "")
          ) {
            this.leaveDialogVisible = true;
            this.leaveCallback = () => {
              // 关闭窗口
              window.ReplyElectronApi.closeWin();
            };
          } else {
            // 关闭窗口
            window.ReplyElectronApi.closeWin();
          }
        });
      }
      if (window.isElectron) {
        window.ipcRenderer.on("get-replay-notice", (event, params) => {
          if (params && params.type === "update-note") {
            this.apiGetNoteInfo({
              lesson_id: this.lessonInfo.id,
            });
          }
        });
      }
    },
    checkLeaveStatus(callback) {
      if (
        ["video-play-note", "ai-mode-note"].includes(this.componentId) &&
        !this.isEmpty &&
        this.initNoteContent !== this.noteContent
      ) {
        this.leaveDialogVisible = true;
        this.leaveCallback = callback;
      } else {
        callback();
      }
    },
    // 给编辑器插入标记
    handleInsertMarkBlock(data = {}) {
      this.editor.focus();
      this.editor.move(9999999999);
      this.editor.emit("xhInsertMarkBlock", {
        type: data.type, // 1 标记块类型，1：自定义，2：重点 3 疑问
        time: data.time,
        content: data.content,
        imgUrl: data.imgUrl,
        file: data.file,
      });
      this.editor.move(9999999999);
    },
    // 给编辑器插入图片
    handleInsertImage(data = {}) {
      // 光标聚焦到最后
      this.editor.focus();
      this.editor.move(9999999999);
      this.editor.emit("xhInsertImage", {
        url: data.url,
        file: data.file,
      });
      this.editor.move(9999999999);
    },
    // 给编辑器插入问答
    handleInsertQABlock(data = {}) {
      this.editor.focus();
      this.editor.move(9999999999);
      this.editor.emit("xhInsertQABlock", {
        qContent: data.question,
        aContent: data.answer,
      });
      this.editor.move(9999999999);
    },
    // 给编辑器插入内容
    handleInsertHtml(html = "") {
      this.editor.emit("xhInsertHtml", html);
    },
    // 操作插入标记块
    noticeInsertMarkBlock(data) {
      console.log("通知插入标记块》〉》〉》", data);
      EventBus.$emit(`notice-insert-mark-block`, data);
    },
    // 通知视频截图
    noticeInsertVideoScreenShot() {
      console.log("通知视频截图");
      EventBus.$emit(`notice-video-screen-shot`);
      // this.editor.emit("xhInsertImage", {
      //   url: "https://img0.baidu.com/it/u=600722015,3838115472&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=750",
      // });
    },
    // 跳转到指定时间
    noticeJumpPlayTime(time) {
      console.log("跳转到指定时间", time);
      EventBus.$emit("notice-jump-play-time", time);
    },
    onEditorCreated(editor) {
      this.editor = editor;
      // 初始化
      // console.log(333333);
      // console.log(this.lessonInfo);
      // if (this.lessonInfo.id) {
      //   this.apiGetNoteInfo({
      //     lesson_id: this.lessonInfo.id,
      //   });
      // }
    },
    onClickExport() {
      if (this.isEmpty) {
        return;
      }
      this.onClickSave(false, () => {
        if (window.isElectron) {
          const params = {
            name: "Note",
            params: {
              lessonId: this.lessonInfo.id,
            },
          };
          if (window.ReplyElectronApi?.mainWinJumpUrl) {
            // 主窗口-跳转笔记页
            window.ReplyElectronApi.mainWinJumpUrl(params);
          } else if (window.mainWin) {
            this.$router.push(params);
          }
        } else {
          window.open(`/note/${this.lessonInfo.id}`);
        }
      });
    },
    onClickSave(isShowTips = true, callback, isAi) {
      if ((this.isEmpty && !isAi) || this.editorReadOnly) {
        return;
      }
      const html = this.editor.getHtml();
      saveLessonNote({
        course_id: this.lessonInfo.course_id,
        lesson_id: this.lessonInfo.id,
        id: this.noteDetail.id || 0,
        summary: extractTextFromHtml(html)?.text,
        unit_id: this.lessonInfo.unit_id,
        content: html,
        is_ai: isAi ? 1 : 0, // 1 ai 2 非ai 0:不更新字段
      })
        .then((res) => {
          if (res.code === 1) {
            this.setNoteContent(html);
            this.setInitNoteContent();
            if (isShowTips) {
              this.isShowSuccess = true;
              setTimeout(() => {
                this.isShowSuccess = false;
              }, 3000);
            }
            // if (
            //   window.isElectron &&
            //   window.ReplyElectronApi &&
            //   window.ReplyElectronApi.replayNotice
            // ) {
            //   window.ReplyElectronApi.replayNotice({
            //     type: "update-note",
            //   });
            // }
          } else {
            if (isShowTips) {
              this.isShowFail = true;
              setTimeout(() => {
                this.isShowFail = false;
              }, 3000);
            }
          }
        })
        .catch(() => {
          if (isShowTips) {
            this.isShowFail = true;
            setTimeout(() => {
              this.isShowFail = false;
            }, 3000);
          }
        })
        .finally(() => {
          if (callback) {
            callback();
          }
        });
    },
    confirmLeave() {
      if (this.isEmpty) {
        return;
      }
      const html = this.editor.getHtml();
      saveLessonNote({
        course_id: this.lessonInfo.course_id,
        lesson_id: this.lessonInfo.id,
        id: this.noteDetail.id || 0,
        summary: extractTextFromHtml(this.editor.getHtml())?.text,
        unit_id: this.lessonInfo.unit_id,
        content: this.editor.getHtml(),
      }).then((res) => {
        if (res.code === 1) {
          this.setNoteContent(html);
          this.setInitNoteContent();
          this.$message.success("保存成功");
          setTimeout(() => {
            this.leaveCallback(true);
          }, 500);
          // if (
          //   window.isElectron &&
          //   window.ReplyElectronApi &&
          //   window.ReplyElectronApi.replayNotice
          // ) {
          //   window.ReplyElectronApi.replayNotice({
          //     type: "update-note",
          //   });
          // }
        } else {
          this.$message.error(res.message);
        }
      });
    },
    cancelSave() {
      this.setInitNoteContent();
      this.leaveCallback && this.leaveCallback(true);
    },
    // 获取笔记
    getNote() {
      this.setNoteContent("");
      this.setInitNoteContent();
      this.apiGetNoteInfo({
        lesson_id: this.lessonInfo.id,
      })
        .then((res) => {
          if (res.code !== 1) {
            this.$emit("loadFail");
          }
        })
        .catch((err) => {
          this.$emit("loadFail");
        });
    },
  },
  computed: {
    ...mapState("replay", ["noteContent", "initNoteContent", "noteDetail"]),
    showAdjustTips() {
      if (!this.noteDetail.material_id || !this.lessonInfo.material_id) {
        return false;
      } else {
        return this.noteDetail.material_id !== this.lessonInfo.material_id;
      }
    },
    isLive() {
      if (this.lessonInfo) {
        if (this.lessonInfo.lesson_type === 1) {
          // 点播
          return false;
        } else {
          if (this.lessonInfo.record_url) {
            // 有回放当作点播
            return false;
          } else {
            return true;
          }
        }
      } else {
        return false;
      }
    },
    toolbarKeys() {
      if (this.componentId === "video-play-note" && window.isElectron) {
        return ["insertFormula", "bold", "italic", "underline"];
      } else {
        return [
          "insertFormula",
          "bold",
          "italic",
          "underline",
          "|",
          "xhVideoScreenShotKey",
          "xhMarkBlockKey",
        ];
      }
    },
    handleLessonInfo() {
      const { id, course_id, unit_id } = this.lessonInfo;
      return {
        lesson_id: id,
        course_id,
        unit_id,
      };
    },
  },
  watch: {
    "lessonInfo.id": {
      handler(val) {
        if (val) {
          this.getNote();
        }
      },
      immediate: true,
    },
    componentId: {
      async handler(val) {
        if (window.isElectron && val === "video-play-note") {
          EventBus.$off("video-play-note-update");
          EventBus.$on("video-play-note-update", ({ lessonId }) => {
            console.log(
              "video-play-note-update",
              Number(this.lessonInfo.id),
              Number(this.lessonInfo.id)
            );
            this.editorReadOnly = false;
            if (Number(this.lessonInfo.id) === Number(lessonId)) {
              this.apiGetNoteInfo({
                lesson_id: this.lessonInfo.id,
              });
            }
          });

          //判断当前视频播放窗口的lessonId是否与当前笔记的lessonId一致
          let exitUrl = await window.checkWinExist({
            winName: "replayWin",
          });
          console.log("video-play-note-exitUrl", exitUrl);
          if (exitUrl) {
            const lessonId = getLessonIdFromReplayWinUrl("#" + exitUrl);
            console.log(
              "video-play-note-lessonId",
              Number(lessonId),
              Number(this.lessonInfo.id)
            );
            if (Number(this.lessonInfo.id) === Number(lessonId)) {
              this.editorReadOnly = true;
            }
          }

          // 监听视频播放窗口关闭--取消笔记禁用
          EventBus.$off("video-play-note-disabled");
          EventBus.$on("video-play-note-disabled", ({ lessonId }) => {
            console.log(
              "video-play-note-disabled",
              Number(lessonId),
              Number(this.lessonInfo.id)
            );

            if (Number(this.lessonInfo.id) === Number(lessonId)) {
              this.editorReadOnly = true;
            }
          });
        }
      },
      immediate: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.comp-container {
  height: 100%;
  padding: 8px;
  .adjust-tips {
    font-weight: 400;
    font-size: 12px;
    color: #ff7d00;
    line-height: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    background: #fff7e8;
    border-radius: 6px 6px 0 0;
    padding-left: 6px;
    img {
      width: 18px;
      height: 18px;
      margin-right: 4px;
    }
  }
  .content-container {
    background: rgba(255, 255, 255, 0.6);
    border-radius: 6px;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  .content-container-show-adjust-tips {
    border-radius: 0 0 6px 6px;
  }
  .live-box {
    background: rgba(255, 255, 255, 0.6);
    border-radius: 6px;
    height: 100%;
    display: flex;
    flex-direction: column;
    text-align: center;
    display: flex;

    align-items: center;
    img {
      margin-top: 100px;
      width: 100px;
      height: 100px;
    }
    p {
      margin-top: 10px;
      font-weight: 400;
      font-size: 12px;
      color: #515350;
      line-height: 17px;
    }
  }
  .header {
    height: 33px;
    line-height: 33px;
    border-bottom: 1px solid #fff;
    padding: 0 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .lesson-name {
      font-weight: 400;
      font-size: 12px;
      color: #515350;
      width: 190px;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    .handle-tip {
      font-weight: 400;
      font-size: 12px;
      color: #515350;
      margin-left: 8px;
      flex: 1;
      .tips {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        img {
          width: 12px;
          height: 12px;
        }
        p {
          margin-left: 3px;
          font-weight: 400;
          font-size: 12px;
          color: #515350;
          line-height: 17px;
        }
      }
    }
  }
  .main {
    flex: 1;
    position: relative;
    overflow: hidden;
    &.editor-container-disabled {
      // pointer-events: none;
      cursor: not-allowed;
      .comp-container__editor {
        pointer-events: none;
      }
    }
    .editor ::v-deep {
      border: none;
      .comp-container__editor-toolbar {
        border-bottom: 1px solid #fff;
        .w-e-toolbar {
          background: transparent;
        }
      }
      .comp-container__editor-content {
        flex: 1;
        overflow-y: auto;
        .w-e-text-container {
          background: transparent;
        }
        .w-e-scroll {
          &::-webkit-scrollbar {
            width: 4px;
          }
          &::-webkit-scrollbar-thumb {
            background: transparent;
            border-radius: 2px;
          }
        }
      }
    }
    .handle-box {
      position: absolute;
      right: 6px;
      top: 4px;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-end;
      .btn {
        width: 32px;
        height: 22px;
        background: #ffffff;
        border-radius: 4px;
        font-weight: 400;
        font-size: 11px;
        color: #0d1400;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        &:hover {
          background: #f2f3f5;
        }
        &.disabled {
          cursor: not-allowed;
          color: #c9cdd4;
          &:hover {
            background: #ffffff;
          }
        }
      }
      .save-btn {
        margin-left: 4px;
      }
    }
  }
}
.remove-conent {
  .tips {
    font-weight: 400;
    font-size: 14px;
    color: #515350;
    line-height: 22px;
    margin-top: 10px;
    margin-bottom: 30px;
    text-align: center;
  }
  .btn-box {
    text-align: center;
  }
}
</style>
